module.exports = __webpack_public_path__ + "img/Myovant_logo@2x.a833756a.png";